module.exports = __webpack_public_path__ + "img/3-squoll-fil-questions-reponses-md.9ed21e68.png";